import routes from 'defs/routes';
import noop from 'helper/noop';
import { compileDynamicRoute } from 'helper/string';

import { IPatchController } from 'types/PatchController';
import { HistoryType, MatchType } from 'types/withRouter';

const notImplemented = (Controller: IPatchController, method: string) =>
	new Error(`${Controller.constructor.name} does not implement abstract controller method '.${method}()'.`);

/**
 * Abstract PatchController class for handling deep-link/url patching
 * @author Jan Biasi <jan.biasi@namics.com>
 * @class PatchController
 */
class PatchController implements IPatchController {
	private _history: HistoryType;
	private _match: MatchType;
	private _params: any;

	constructor(history: HistoryType, match: MatchType, params: any = {} as any) {
		this._history = history;
		this._match = match;
		this._params = params;
	}

	get history(): HistoryType {
		return this._history;
	}

	get match(): MatchType {
		return this._match;
	}

	get params(): any {
		return this._params;
	}

	get routes() {
		return routes;
	}

	public compileDynamicRoute(route: string, data: any): string {
		return compileDynamicRoute(route, data);
	}

	public redirect(url: string, data?: any, replace: boolean = true) {
		const historyHandler = this._history[replace ? 'replace' : 'push'] || noop;

		if (typeof data === 'object') {
			historyHandler(this.compileDynamicRoute(url, data));
		} else {
			historyHandler(url);
		}
	}

	public prepare(done) {
		return done();
	}

	public handle() {
		throw notImplemented(this, 'handle');
	}

	public finish() {
		return false;
	}

	public catch() {
		throw notImplemented(this, 'catch');
	}
}

export default PatchController;
